export default __webpack_public_path__ + "static/media/no.6df96bb2.svg";